import styled from "styled-components/macro";

export const StyledQuotaDisplayBar = styled.div`
  width: 80%;
  background: var(--menu-color-active);
  height: 6px;
  margin: 10px;
  margin-left: 10%;
  border-radius: 5px;
  overflow: hidden;

  div {
    background: var(--primary-cta-high-contrast);
    height: 6px;
    width: ${({ filledAmount }) => filledAmount && `${filledAmount}%`};
  }
`;

export const StyledQuotaDisplayText = styled.span`
  &.settings-quota-bar-display-text {
    display: block;
    padding: 0 20px;
    font-size: 12px;
    text-align: center;
    line-height: 130%;
    font-weight: 500;
    color: var(--grey-1) a {
      display: block;
      margin-top: 5px;
    }
    a,
    button {
      margin-top: 3px !important;
      display: inline-block !important;
      background: transparent !important;
      font-weight: regular;
      color: var(--grey-1) !important;
      font-size: 12px !important;
      border-radius: 3px !important;
    }
  }
`;

export const StyledQuotaBar = styled.div`
  a,
  button {
    color: var(--grey-1);
    text-decoration: underline;
    cursor: pointer;
  }

  button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    min-width: unset;
  }

`;
